import { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Collapse,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const faqs = [
  {
    question: "Why do I need to scan a QR code?",
    answer: "When you scan the QR code, it opens our web app so you can access the Augmented Reality [ar] experience.",
  },
  {
    question: "Do I need to scan the QR code multiple times?",
    answer: "Each QR code is connected to one or more [ar] experiences (images). You only need to scan the QR code once to access each experience. Some experiences have just one image and some have multiple images that come to life. When in doubt, scan the QR code to load each experience.",
  },
  {
    question: "What is Augmented Reality [ar]?",
    answer: "Augmented reality is a technology that superimposes a digital experience on or in your natural environment for the purpose of education and/or entertainment.",
  },
  {
    question: "What is the benefit of downloading the full app?",
    answer: "By downloading the full version of the app, you can now scan the QR code(s) with the app and also access additional features and [ar] content. You will also be able to access select [ar] experiences in areas where cell service is not available.",
  },
];

export const FAQView = ({ onClose }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 1100,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "74px",
        }}
      >
        <Typography
          sx={{
            fontSize: 30,
            fontWeight: "bold",
            color: "yellow",
          }}
        >
          FAQ
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            position: "fixed",
            top: 12,
            right: 12,
            width: 50,
            height: 50,
            backgroundColor: "rgba(0,0,0,0.5)",
            color: "white",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
          }}
        >
          <ArrowForwardIcon fontSize="large" />
        </IconButton>
      </Box>

      {/* FAQ list */}
      <Box sx={{ overflowY: "auto", flex: 1, px: 3 }}>
        {faqs.map((faq, index) => (
          <Box key={index}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              onClick={() => handleToggle(index)}
              sx={{ cursor: "pointer", py: 1 }}
            >
              <Typography
                sx={{
                  color: "white",
                  fontSize: 28,
                  pr: 5,
                  lineHeight: 1.4,
                }}
              >
                {faq.question}
              </Typography>

              {expandedIndex === index
                ? <ExpandLessIcon sx={{ color: "white", flexShrink: 0 }} />
                : <ExpandMoreIcon sx={{ color: "white", flexShrink: 0 }} />
              }
            </Stack>

            <Collapse in={expandedIndex === index}>
              <Typography
                sx={{
                  color: "white",
                  fontSize: 24,
                  pt: 1,
                  pb: 3,
                }}
              >
                {faq.answer}
              </Typography>
            </Collapse>

            <Divider sx={{ backgroundColor: "white" }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};